module.exports = __webpack_public_path__ + "static/news-5-3f6a45ebcc76b6504c0711bc2be9b3ed.png";